// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Po3g","row":"styles_row__3XaXQ"};